import { render } from "./ProductOverlay.vue?vue&type=template&id=59c362f3&ts=true"
import script from "./ProductOverlay.vue?vue&type=script&lang=ts"
export * from "./ProductOverlay.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__